import { configureStore } from '@reduxjs/toolkit';
import signupReducer from './slices/signupSlice';
import authReducer from './slices/authSlice';
import notificationsReducer from './slices/notificationsSlice';
import meetingsReducer from './slices/meetingsSlice';
import contactsReducer from './slices/contactsSlice';
import profileCardsReducer from './slices/profileCardsSlice';
import impersonationReducer from './slices/impersonationSlice';
import loungeReducer from './slices/loungeSlice';

export const store = configureStore({
  reducer: {
    signup: signupReducer,
    auth: authReducer,
    notifications: notificationsReducer,
    meetings: meetingsReducer,
    contacts: contactsReducer,
    // Profile-card cache for the chat preview feature. Keyed by
    // `${type}:${id}` so two chat messages referencing the same player
    // only fire one network fetch (TTL enforced by useProfileCard hook).
    profileCards: profileCardsReducer,
    // "View as" role preview presence/target (TP-View-As, superuser tool).
    impersonation: impersonationReducer,
    // Agent Lounge unread badge only (nav Sofa + Activity button share it).
    lounge: loungeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['signup/setSignupData', 'signup/setAgencyDetails'],
        ignoredPaths: ['signup.agencyDetails.logo'],
      },
    }),
});

export default store; 